import { render, staticRenderFns } from "./InvestmentTransferHistoryWidget.vue?vue&type=template&id=592313b0"
import script from "./InvestmentTransferHistoryWidget.vue?vue&type=script&lang=ts"
export * from "./InvestmentTransferHistoryWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports